import { useState, useEffect } from 'react';
import CateCard from './CateCard';
import { useTranslation } from 'react-i18next';

function HomeStyleCate(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { langs, stat, setStat } = props;
  const { t } = useTranslation();
  const machineID = props.id;

  let machine = JSON.parse(localStorage.getItem('machine'));

  const bColumn = () => {
    let c = machine;
    let result = '1';
    if (c.themeColor && c.themeColor.b_column) {
      result = c.themeColor.b_column === '3' ? '1' : c.themeColor.b_column;
    }
    return result;
  };

  const b_column = bColumn();

  const fColumn = () => {
    let c = machine;
    let result = '1';
    if (c.themeColor && c.themeColor.c_column) {
      result = c.themeColor.c_column === '3' ? '1' : c.themeColor.c_column;
    }
    return result;
  };

  const [cate, setCates] = useState([]);
  const [column, setColumn] = useState('1');
  const [input, setInput] = useState('');
  const [languages, setLanguage] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    setColumn(fColumn());

    setCates(
      JSON.parse(localStorage.getItem('category'))
        ? JSON.parse(localStorage.getItem('category'))
        : []
    );
    setLanguage(
      JSON.parse(localStorage.getItem('machine'))
        ? JSON.parse(localStorage.getItem('machine')).languages
        : null
    );
  }, []);

  let result;

  result = [...cate];

  //sort by name
  result = result?.sort((a, b) => {
    const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
    const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  const allCat = {
    key: 1,
    id: 1,
    name: {
      en: 'All Products',
      fr: 'Tous les produits',
      es: 'Todos los productos',
    },
    image:
      'https://jvmsaas.com/media/blog/cache/840x620/magefan_blog/Fashion-Shoes-Jewelry-2X._V510055193_3.jpg',
    machineID: machineID,
  };

  const brands = {
    key: 2,
    id: 2,
    name: {
      en: 'Brands',
      fr: 'Marques',
      es: 'Marcas',
    },
    image:
      'https://toplistin.com/wp-content/uploads/2020/03/Most-Popular-Streamed-Game-of-2020-1.png',
    machineID: machineID,
  };
  //apply all product image to brand cate if ...
  if (machine?.themeColor?.allProduct) {
    if (isLocal) {
      allCat.image = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor.allProduct}`;
      brands.image = `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor.allProduct}`;
    } else {
      allCat.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allProduct}/${machine.belongTo}`;
      brands.image = `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor.allProduct}/${machine.belongTo}`;
    }
  }

  if (isLocal)
    if (input.length > 0) {
      result = cate.filter((category) =>
        category.name[langs]?.toLowerCase().includes(input.toLowerCase())
      );
    }

  useEffect(() => {
    if (stat.all_cate) stat.all_cate = stat.all_cate += 1;
    else stat.all_cate = 1;
    setStat(stat);
    localStorage.setItem(
      'currentCate',
      JSON.stringify({
        name: { en: 'All Products', fr: 'Tous les produits', es: 'Todos los productos' },
      })
    );
  }, []);

  const categories = result.map((cate) => {
    const Canme = cate.name[langs] && cate.name[langs] !== '' ? cate.name[langs] : cate.name?.en;
    return (
      <div
        key={cate._id}
        className="row justify-content-center mb-4"
        onClick={() => {
          localStorage.setItem('currentCate', JSON.stringify(cate));
        }}
      >
        <CateCard
          brandOrCate="cate"
          column={column}
          id={cate._id}
          machineID={machineID}
          catename={Canme}
          cateEn={cate.name.en}
          image={
            isLocal
              ? `${process.env.REACT_APP_LOCAL_API}/pictures/category/${cate.categoryPicture}`
              : `${process.env.REACT_APP_SERVER_API}/pictures/${cate.categoryPicture}/${cate.referTo}`
          }
        />
      </div>
    );
  });

  if (b_column !== '0') {
    categories.unshift(
      <div key={2} className="row justify-content-center mb-4">
        <CateCard
          column={column}
          id={2}
          machineID={brands.machineID}
          catename={brands.name[langs]}
          cateEn={brands.name.en}
          image={brands.image}
        />
      </div>
    );
  }

  categories.unshift(
    <div key={1} className="row justify-content-center mb-4">
      <CateCard
        column={column}
        brandOrCate="all"
        id={1}
        machineID={allCat.machineID}
        catename={allCat.name[langs]}
        cateEn={allCat.name.en}
        image={allCat.image}
      />
    </div>
  );

  return (
    <div className="ui-secondary-div">
      <div className="container">
        <div className="row justify-content-center mt-5 mb-5">
          <span className="homeProductText">
            {result.length == 0 ? (
              <h2>{t(`No matching categories is found`)}!</h2>
            ) : (
              t('Categories').toUpperCase()
            )}
          </span>
        </div>
        <div
          className="items-container"
          style={{ display: 'grid', gridTemplateColumns: `repeat(${column}, 1fr)` }}
        >
          {categories}
        </div>
      </div>
    </div>
  );
}
export default HomeStyleCate;
